import "../components/wish-list-delete";
import '../../off-canvas/off-canvas';
import { BaseComponent } from '../../base-component/base-component';
import { OffCanvasConfigs } from '../../off-canvas/interfaces/off-canvas.interface';
import { WISH_LIST_OFF_CANVAS_IDS } from '../interfaces/wish-list-off-canvas.interface';
import { booleanConverter } from '../../../common/converters';
import { customElement, property } from 'lit/decorators.js';
import { html, nothing, TemplateResult } from 'lit';

@customElement('mhecomm-wish-list-delete-off-canvas')
export class WishListCreateOffCanvas extends BaseComponent {

  @property({type: Number})
  wishListId;

  @property()
  wishListName;

  /**
  * The prefix for the delete wish list confirmation message.
  */
  @property()
  deleteWishListPrefix = 'Are you sure you want to delete your list';

  /**
   * If the component is used in the wish list item page, the component will redirect after deletion.
   */
  @property({ converter: booleanConverter })
  isWishListItemPage = false;

  /**
   * Displays the off-canvas for deleting a wishlist.
   */
  renderComp(): TemplateResult | typeof nothing {
    return html`
      <mhecomm-off-canvas .offCanvasConfigs="${this.getOffCanvasConfigs()}">
        <div slot=${WISH_LIST_OFF_CANVAS_IDS.DELETE_WISH_LIST_MY_LISTS + "-off-canvas-body"}>
          <mhecomm-delete-wish-list
            offCanvasId="${WISH_LIST_OFF_CANVAS_IDS.DELETE_WISH_LIST_MY_LISTS}"
            wishListId="${this.wishListId!}"
            wishListName="${this.wishListName!}"
            isWishListItemPage="${this.isWishListItemPage}"
          ></mhecomm-delete-wish-list>
        </div>
      </mhecomm-off-canvas>
    `
  }

  /**
   * Returns the off-canvas list for the component.
   *
   * This configuration is updated based on the states.
   */
  private getOffCanvasConfigs(): OffCanvasConfigs {
    return {
      [WISH_LIST_OFF_CANVAS_IDS.DELETE_WISH_LIST_MY_LISTS]: {
        id: WISH_LIST_OFF_CANVAS_IDS.DELETE_WISH_LIST_MY_LISTS,
        title: html`
          <div>
            ${this.deleteWishListPrefix} named <span class="fw-bold">${this.wishListName}</span>
          </div>
        `,
        closeTriggerId: `#delete-wish-list-${this.wishListId}-cancel`
      }
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-wish-list-delete-off-canvas': WishListCreateOffCanvas;
  }
}